import React, { Component, useContext, useState, useEffect } from "react";
import { Navigate, Link, useLocation, useNavigate } from "react-router-dom";
import AppContext from "../../../AppContext";

import {
  MDBCollapse,
  MDBRipple,
  MDBListGroup,
  MDBListGroupItem,
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBIcon,
} from "mdb-react-ui-kit";

function AdminNavbar() {
  const url = window.location.href;
  const context = useContext(AppContext);
  const [activeItem, setActiveItem] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (url.includes("toszabalyzat")) {
      setActiveItem("1");
    }
    if (url.includes("hazirend")) {
      setActiveItem("2");
    }
    if (url.includes("arlista")) {
      setActiveItem("3");
    }
    if (url.includes("bufe")) {
      setActiveItem("4");
    }
    if (url.includes("horgaszbolt")) {
      setActiveItem("5");
    }
    if (url.includes("berles")) {
      setActiveItem("6");
    }
    if (url.includes("galeria")) {
      setActiveItem("7");
    }
    if (url.includes("news")) {
      setActiveItem("7");
    }
  }, []);

  const toggle = (tab) => {
    console.log(tab);
    if (activeItem !== tab) {
      setActiveItem(tab);
    }
  };

  const onLogout = () => {
    context.onLogout();
    navigate("/admin");
  };

  return (
    <>
      <MDBCollapse show={true} tag="nav" className="admin-navbar" style={{ height: "auto" }}>
        <div id="adminLandingPage" className="position-sticky">
          <>
            <MDBListGroup>
              <MDBRipple rippleTag="span">
                <MDBListGroupItem
                  action
                  onClick={() => {
                    toggle("1");
                    navigate("/admin/fileupload", {
                      state: {
                        filename: "szabalyzat",
                      },
                    });
                  }}
                  active={activeItem === "1"}
                  aria-current={activeItem === "1"}
                >
                  <div className="navbar-text">
                    <span>Tó szabályzata</span>
                  </div>
                </MDBListGroupItem>
              </MDBRipple>

              <MDBRipple rippleTag="span">
                <MDBListGroupItem
                  action
                  onClick={() => {
                    toggle("2");
                    navigate("/admin/fileupload", {
                      state: {
                        filename: "hazirend",
                      },
                    });
                  }}
                  active={activeItem === "2"}
                  aria-current={activeItem === "2"}
                >
                  <div className="navbar-text">
                    <span>Faház - házirend</span>
                  </div>
                </MDBListGroupItem>
              </MDBRipple>

              <MDBRipple rippleTag="span">
                <MDBListGroupItem
                  action
                  onClick={() => {
                    toggle("3");
                    navigate("/admin/fileupload", {
                      state: {
                        filename: "arlista",
                      },
                    });
                  }}
                  active={activeItem === "3"}
                  aria-current={activeItem === "3"}
                >
                  <div className="navbar-text">
                    <span>Árak</span>
                  </div>
                </MDBListGroupItem>
              </MDBRipple>

              <MDBRipple rippleTag="span">
                <MDBListGroupItem
                  action
                  onClick={() => {
                    toggle("4");
                    navigate("/admin/fileupload", {
                      state: {
                        filename: "bufe",
                      },
                    });
                  }}
                  active={activeItem === "4"}
                  aria-current={activeItem === "4"}
                >
                  <div className="navbar-text">
                    <span>Büfé</span>
                  </div>
                </MDBListGroupItem>
              </MDBRipple>

              <MDBRipple rippleTag="span">
                <MDBListGroupItem
                  action
                  onClick={() => {
                    toggle("5");
                    navigate("/admin/fileupload", {
                      state: {
                        filename: "horgaszbolt",
                      },
                    });
                  }}
                  active={activeItem === "5"}
                  aria-current={activeItem === "5"}
                >
                  <div className="navbar-text">
                    <span>Horgászbolt</span>
                  </div>
                </MDBListGroupItem>
              </MDBRipple>
              <MDBRipple rippleTag="span">
                <MDBListGroupItem
                  action
                  onClick={() => {
                    toggle("6");
                    navigate("/admin/fileupload", {
                      state: {
                        filename: "berles",
                      },
                    });
                  }}
                  active={activeItem === "6"}
                  aria-current={activeItem === "6"}
                >
                  <div className="navbar-text">
                    <span>Bérlési lehetőségek</span>
                  </div>
                </MDBListGroupItem>
              </MDBRipple>
              <MDBRipple rippleTag="span">
                <MDBListGroupItem
                  action
                  onClick={() => {
                    toggle("7");
                    navigate("/admin/galery");
                  }}
                  active={activeItem === "7"}
                  aria-current={activeItem === "7"}
                >
                  <div className="navbar-text">
                    <span>Galéria</span>
                  </div>
                </MDBListGroupItem>
              </MDBRipple>
              <MDBRipple rippleTag="span">
                <MDBListGroupItem
                  action
                  onClick={() => {
                    toggle("8");
                    navigate("/admin/news");
                  }}
                  active={activeItem === "8"}
                  aria-current={activeItem === "8"}
                >
                  <div className="navbar-text">
                    <span>Újdonságok</span>
                  </div>
                </MDBListGroupItem>
              </MDBRipple>
            </MDBListGroup>
            <div className="d-flex align-items-center justify-content-center justify-content-center pt-5">
              <button type="btn" className="normal-button" onClick={onLogout}>
                <span>Kijelentkezés</span>
              </button>
            </div>
          </>
        </div>
      </MDBCollapse>
    </>
  );
}
export default AdminNavbar;
